/** 青山科技奖章程 */
import React from 'react';
import './index.scss';
export default function article() {
  return (
    <div className="rule-wrap-kc">
      <div className="sx-title">第一章 总 则</div>
      <div className="sx-content"></div>
      <div className="sx-title">第一条</div>
      <div className="sx-content">
        在中国科协指导下，美团与中国科协生态环境产学联合体及有关学会和机构共同开展“‘科创中国’美团青山环保科技创新示范项目”(以下简称“示范项目”)，以科技促进环保，以示范引领创新，遴选支持一批可应用于外卖领域的、具备创新引领力、具备市场化规模化潜力的绿色低碳科技成果，助力实现碳达峰、碳中和目标，共建美丽中国。
      </div>
      <div className="sx-title">第二条</div>
      <div className="sx-content">为提高示范项目申报遴选规范性，制定本管理办法。</div>
      <div className="sx-title">第二章 组织机构</div>
      <div className="sx-title">第三条</div>
      <div className="sx-content">
        美团为示范项目发起单位，中国科协生态环境产学联合体(简称“联合体”)为联合发起单位，中国环境科学学会、中国石油和化学工业联合会、中国循环经济协会、中国包装联合会、中国物资再生协会、中国生态学学会、中国可再生能源学会、中国复合材料学会、国家生态环境科技成果转化综合服务平台、中国塑料加工工业协会、中国制浆造纸研究院有限公司等单位为联合支持单位。
      </div>
      <div className="sx-title">第四条</div>
      <div className="sx-content">管理委员会：由中国科协、美团、中国科协生态环境产学联合体及联合支持单位组建，负责制定实施办法、审核并批准评审标准及评审结果。</div>
      <div className="sx-title">第五条</div>
      <div className="sx-content">专家委员会：由美团、中国科协生态环境产学联合体及联合支持单位推荐行业知名专家组成，负责制定评审标准、开展评审工作。</div>
      <div className="sx-title">第六条</div>
      <div className="sx-content">项目办公室：由美团和中国科协生态环境产学联合体有关人员组成，负责整体项目的运营，包括申报渠道建设、申报项目形式审查、评审工作组织和成果评估展示等。</div>
      <div className="sx-title">第七条</div>
      <div className="sx-content">本管理办法所称申报单位是指申报“示范项目”的企业、高校、研究机构、社会组织等。</div>
      <div className="sx-title">第三章 申报要求</div>
      <div className="sx-title">第八条 支持方向：</div>
      <div className="sx-content">(一)【绿色创新包装】环境友好材料、绿色创新设计和先进工艺在餐饮外卖包装领域的应用，以实现外卖包装的减量化和易回收易再生。包括但不限于：</div>
      <div className="sx-content">• 满足餐饮外卖包装基本功能的前提下，开发低克重高强度、减量化的绿色包装；</div>
      <div className="sx-content">• 开发单一材质或便于不同材质分离，能够显著提升可回收可再生性的易回收、易再生餐饮外卖包装。</div>
      <div className="sx-content">(二)【绿色回收再生】餐饮外卖包装回收、分拣、清洗、再生和高值化利用等先进绿色低碳循环技术示范试点。包括但不限于：</div>
      <div className="sx-content">• 通过回收模式与技术的创新应用，实现塑料餐盒、饮品杯和包装袋等餐饮外卖包装的规模化回收；</div>
      <div className="sx-content">• 利用先进智能分拣系统应用，实现针对餐饮外卖包装材质的精准分拣，促进外卖餐饮包装规模化回收提效；</div>
      <div className="sx-content">• 开发回收塑料再生利用、改性等创新技术，实现聚丙烯(PP)等塑料再生颗粒高值化创新应用。</div>
      <div className="sx-content">(三)【绿色供应链体系】外卖行业绿色包装供应链体系的数字化应用。包括但不限于：</div>
      <div className="sx-content">• 面向餐饮商家在绿色包装方面的多样化、个性化需求，开发数字化、信息化平台；</div>
      <div className="sx-content">• 通过数字化手段提升回收再生产业链的运营效率(如回收路径优化等)及信息透明度，实现溯源并有效促进再生资源高效回收利用。</div>
      <div className="sx-title">第九条 申报条件：</div>
      <div className="sx-content">(一)项目申报单位需为中国境内依法注册的法人主体，近3年内未发生重大质量、环保或安全事故，没有违法行为或涉嫌违法正在接受调查的情况；</div>
      <div className="sx-content">(二)申报单位在其所申报领域具有创新技术优势，具有与项目相关的研发能力和自主知识产权或授权；</div>
      <div className="sx-content">(三)项目应属于绿色创新包装、绿色回收再生以及绿色供应链体系三个领域之一；</div>
      <div className="sx-content">(四)项目应符合法律法规和国家产业政策，产出需体现明确的外卖包装废弃物减量减排和绿色低碳环保效益；</div>
      <div className="sx-content">(五)项目应具备创新性，较高技术成熟度或完成初步产业化；</div>
      <div className="sx-content">(六)项目应有明确的项目建设方案，规范的投资预算和投融资方案，并提供办理项目相关手续的证明；</div>
      <div className="sx-content">(七)项目申请资助比例不高于投资总额的50%；</div>
      <div className="sx-content">(八)项目资助期不超过两年，资助期内应完成项目建设和正式投产运行或上线运营；</div>
      <div className="sx-content">(九)曾获本项目资助的申报单位次期不可重复申报。</div>
      <div className="sx-title">第四章 申报与评审</div>
      <div className="sx-title">第十条</div>
      <div className="sx-content">“示范项目”申报要求详情参考《科创中国—美团青山环保科技创新示范项目申报指南》。</div>
      <div className="sx-title">第十一条</div>
      <div className="sx-content">“示范项目”遴选分为意向征集、材料审核、项目初评、项目终审、现场审核及资助额度确认和项目公示六个阶段。</div>
      <div className="sx-content">(一) 意向征集</div>
      <div className="sx-content">申报单位通过填报项目基础信息，提交意向征集的申请材料。项目办公室根据各单位提供的材料进行初步评估筛选，通过的单位将进入正式申报阶段。</div>
      <div className="sx-content">(二) 材料审核</div>
      <div className="sx-content">项目办公室对申报项目资料进行形式审查。形式审查的主要内容包括：申报单位是否符合要求；申报项目是否符合资助范围及申报条件；申报书及附件材料是否有效等。不符合相关要求及申报材料不全的一律不予受理。</div>
      <div className="sx-content">(三) 项目初评</div>
      <div className="sx-content">组织评审专家对通过形式审查的项目进行初评，根据资助范围分绿色创新包装、绿色回收再生及绿色供应链体系三大方向开展评审。</div>
      <div className="sx-content">(四) 项目终审</div>
      <div className="sx-content">组织评审专家对通过初评的入围项目进行终审，候选项目主要完成人或代表汇报答辩，专家进行评审，根据评审结果确定若干项目进入现场审核及资助额度确认环节。</div>
      <div className="sx-content">(五) 现场审核及资助额度确认</div>
      <div className="sx-content">项目办公室将组织专家对必要的候选项目进行现场审核，根据终审结果及现场审核情况确定拟入选项目名单及项目资助额度，报管理委员会批准。现场审核结果与提交申报材料差距较大的项目不予资助。</div>
      <div className="sx-content">(六) 项目公示</div>
      <div className="sx-content">拟入选项目名单将在美团青山科技基金、中国科协生态环境产学联合体等网站进行公示，公示期不少于5个工作日。</div>
      <div className="sx-title">第十二条 异议处理</div>
      <div className="sx-content">(一)公示期内，任何单位/个人均可实名向项目办公室提出异议。提出异议的单位/个人应提供加盖本单位公章/个人签名的书面异议材料和必要的证明文件，以匿名方式提出的异议不予受理。</div>
      <div className="sx-content">(二)异议处理过程中，涉及异议的任何一方应积极配合，不得推诿和延误。必要时，专家委员会将进行调查并提出初步处理意见。</div>
      <div className="sx-content">(三)项目办公室以及其他参与异议调查、处理的有关人员应当对异议者身份予以保密；确需公开的，应事前征求异议者的意见。</div>
      <div className="sx-title">第五章 项目实施</div>
      <div className="sx-title">第十三条</div>
      <div className="sx-content">获资助的申报单位须与美团签订《科创中国-美团青山环保科技创新示范项目资助计划资助合同》。</div>
      <div className="sx-title">第十四条</div>
      <div className="sx-content">项目资助期不超过两年，资助期内申报单位应按照项目总体进度要求保证所申请项目实施进度，完成项目建设和正式投产运行或上线运营，并接受项目执行情况督查。</div>
      <div className="sx-title">第十五条</div>
      <div className="sx-content">本示范项目为公益性资助项目，其成果的完整知识产权(包括电子出版物)、署名权均由示范项目申报单位所有。为了促进科技成果转化，获资助单位及其相关成员在项目执行期间和完成后应积极配合示范项目相关宣传。</div>
      <div className="sx-title">第十六条 项目验收</div>
      <div className="sx-content">按资助合同约定，项目执行期满应进行项目验收。验收方式包括但不限于：</div>
      <div className="sx-content">(一)材料验收：包括但不限于，项目实施过程中涉及项目执行、管理、绩效、总结、经费使用情况和其他与示范项目相关的材料等。</div>
      <div className="sx-content">(二)现场验收：包括但不限于，示范项目仪器设备运行情况、产品生产线、实际生产规模、运营情况等。</div>
      <div className="sx-title">第十七条</div>
      <div className="sx-content">示范项目核心工作须由项目申报单位负责完成，严禁转托其他个人或组织。</div>
      <div className="sx-title">第十八条</div>
      <div className="sx-content">美团将与中国科协生态环境产学联合体、各支持单位共同宣传，扩大示范项目的社会影响及其成果的推广应用。</div>
      <div className="sx-title">第十九条</div>
      <div className="sx-content">在示范项目落地建设的过程中，项目办公室可根据项目申报单位需求和项目实际情况，组织相关专家对项目申报单位进行评估辅导。</div>
      <div className="sx-title">第六章 经费拨付与执行监督</div>
      <div className="sx-title">第二十条</div>
      <div className="sx-content">每期资助不超过10个项目，单个项目资助金额不超过300万元，申请资助比例不高于项目投资总额的50%，资助期不超过两年。经费管理及使用按照项目资助合同执行。</div>
      <div className="sx-title">第二十一条</div>
      <div className="sx-content">本项目为定额资助。资助经费仅可列支以下项目支出：咨询费、交通费、差旅费、劳务费、设备费、材料费、测试化验加工费、审计费、不可预见费、其他商品和服务支出。</div>
      <div className="sx-title">第二十二条</div>
      <div className="sx-content">项目办公室将定期评估项目完成进度及质量，对项目存在严重问题，执行进度严重滞后，或严重违反合同约定内容情节的，将通知申报单位进行整改；如整改期结束仍未达到执行要求，将取消项目经费支持，追回全部或部分资助款项。</div>
      <div className="sx-title">第二十三条</div>
      <div className="sx-content">项目开展信用管理，对项目申报单位及责任人、专家、专业机构等在本项目中的信用情况进行客观记录，并作为其继续参与项目的重要依据。</div>
      <div className="sx-title">第二十四条</div>
      <div className="sx-content">申报单位应保证项目在申报及后续实施过程中均不侵犯任何第三方的知识产权及其他合法权益。对于申报单位与第三方的纠纷或争议，本示范项目发起单位不承担任何责任。</div>
      <div className="sx-title">第二十五条</div>
      <div className="sx-content">申报单位有以下情形的，项目办公室有权对该项目重新审核，并依据其严重程度分别或同时采取暂缓拨款、终止拨款、追回部分或全部资助款项、撤销对该项目的资助以及取消申报单位申报资格等相应措施，并依法追究相关人员责任：</div>
      <div className="sx-content">(一)申报单位在项目实施过程中，侵犯任何第三方的知识产权及其他合法权益；</div>
      <div className="sx-content">(二)项目实施内容、经费支出、成果落地等与《示范项目资助计划资助合同》的约定存在重大差异，或存在弄虚作假、挪用资助资金等情形；</div>
      <div className="sx-content">(三)申报单位有其他严重违法违纪行为。</div>
      <div className="sx-title">第七章 附 则</div>
      <div className="sx-content"></div>
      <div className="sx-title">第二十六条</div>
      <div className="sx-content">本办法由管理委员会负责解释。</div>
      <div className="sx-title">第二十七条</div>
      <div className="sx-content">本办法自印发之日起施行。</div>
      <div className="sx-title text-r">青山科技奖秘书处</div>
      <div className="sx-title text-r">2023年5月</div>
    </div>
  );
}
